import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { CustomerService } from '../../customer/customer.service';

import { BatchstampService } from '../../batchstamp/batchstamp.service';

import { FormBuilder, NgForm } from '@angular/forms';
import { Subject } from 'rxjs/Rx';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Location } from '@angular/common';
import { EvsStampService } from '../../../../../common/services/EvsStamp.service';
import { PagerService } from '../../../../../common/services/Pagination.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { EvsAddressService } from '../../../../../common/services/EvsAddress.service';
import { OrderService } from './order.service';
import { ConfirmationService } from 'primeng/primeng';
import { Message } from 'primeng/components/common/message';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import * as moment from 'moment';
import { environment } from '../../../../../../environments/environment';
import { IOption } from 'ng-select';
import { ExportService } from '../../../../../common/services/Export.service';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

declare var $: any;

@Component({
  selector: "app-order",
  templateUrl: "./order.component.html",
  styleUrls: ["./order.component.css"],
  providers: [
    ConfirmationService,
    EvsAddressService,
    EvsStampService,
    BatchstampService,
    OrderService,
  ],
})
export class OrderComponent implements OnInit, OnDestroy {
  @ViewChild("lgModal") lgModal: ModalDirective;
  @ViewChild("cancelRequest") cancelRequest: ModalDirective;

  no_product = "assets/images/no_product.png";
  no_image = "assets/images/no-image.png";
  listTypeStamp: Array<IOption> = [];
  contactMethods = [
    { id: 1, label: "Email" },
    { id: 2, label: "Phone" },
  ];
  contact = {
    firstName: "CFR",
    comment: "No comment",
    subscribe: true,
    contactMethod: 2, // this id you'll send and get from backend
  };
  public dtOptions: any = {};
  public dtTrigger: Subject<any> = new Subject();
  public currentPage: number = 1;
  public totalRow: number = 0;
  public page_size: number = 10;
  public offset: number = 0;
  public pager: any = {};
  public orders: any = [];
  public message: { class: string; content: string } = null;
  public error: string = "";
  public componentData = null;
  public routerChange: any;
  public model: any = {};
  public paramsQuery: any = {};
  public cities: Array<any> = [];
  public districts: Array<any> = [];
  public msgs: Message[] = [];

  public current_filter: any = {};
  public item_active: any = 0;
  public item_detail: any = {};
  loading_data = true;

  logFilter: any = {
    status: -1,
    type: -1,
    typeStamp: -1,
  };

  public arr_sort = { name: null };
  stamBuy: any = {};
  guarantees: any = [];
  guaranteeCurentpage: number = 1;
  public guaranteeTotalRow: number = 0;
  public guaranteePage_size: number = 10;
  public guaranteePager: any = {};
  public isDisableService: Boolean = false;
  isSorting: any;
  isUpdate: Boolean = false;
  totalItem: any = 0;
  totalPage: any = 0;
  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  public messageExport = '';
  private langSub: Subscription;

  constructor(
    private _location: Location,
    private service: CustomerService,
    private pagerService: PagerService,
    private router: Router,
    public addressService: EvsAddressService,
    private confirmationService: ConfirmationService,
    private activatedRoute: ActivatedRoute,
    private _fb: FormBuilder,
    private toastr: ToastrService,
    private evsStampService: EvsStampService,
    private batchstampService: BatchstampService,
    private orderService: OrderService,
    private exportService: ExportService,
    private translate: TranslateService,
  ) {
    this.item_detail = undefined;
  }

  getCity() {
    this.addressService.getCities().subscribe((res) => {
      let citiesList = [];
      res.data.cities.forEach((c: any) => {
        citiesList.push({
          value: c.name,
          label: c.name,
          id: c.id,
        });
      });
      this.cities = citiesList;
    });
  }

  loadDistrictData(id: number, i: any) {
    this.addressService
      .getDistrict({ city_id: id })
      .toPromise()
      .then((res) => {
        let districts = [];
        res.data.districts.forEach((c: any) => {
          districts.push({
            value: c.name,
            label: c.name,
            id: c.id,
          });
        });
        this.districts = districts;
        if (i != null)
          if (this.districts[this.item_detail.distributions[i].district - 1])
            this.item_detail.distributions[i].district =
              this.districts[
                this.item_detail.distributions[i].district - 1
              ].value;
      });
  }

  loadData(request: any = {}, sort: any) {
    this.loading_data = true;
    if (_.isEmpty(request)) {
      request = this.current_filter;
    }

    request.offset =
      this.page_size * (this.currentPage <= 0 ? 0 : this.currentPage - 1);
    request.limit = this.page_size;
    request.desc = "id";
    delete request.desc;
    delete request.asc;
    if (this.logFilter.status !== -1) {
      request.status = this.logFilter.status;
    }
    request.sort_by = "created_at:" + sort;
    this.orderService
      .getListOrders(request)
      .toPromise()
      .then(
        (res) => {
          this.loading_data = false;
          let error = res.error;
          if (res.status == 200 && res.error == false) {
            this.orders = res.data.orders;

            this.totalItem = res.data.total.count;
            var pageString = (this.totalItem / this.page_size).toString();
            var pageSplit = pageString.split(".");
            var last: any;
            var totalpage = parseInt(pageSplit[0]);
            if (pageSplit.length > 1) {
              last = pageSplit[1];
              if (parseInt(last) > 0) {
                totalpage++;
              }
            }
            this.totalPage = totalpage;
            if (this.orders.length > 0) {
              for (let i = 0; i < this.orders.length; i++) {
                if (this.orders[i].services) {
                  this.orders[i].list_stamp_services = this.buildListServices(this.orders[i].services);
                }
              }
            }
            if (this.orders.length > 0)
              this.viewDetail(this.item_active, this.orders[this.item_active]);
          }
        },
        (err) => { }
      );
  }

  viewDetail(i, data) {
    this.item_detail = null;
    if (this.isUpdate == true) {
      this.toastr.info("Thao tác cập nhật khách hàng đã bị hủy", "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
    }
    this.isUpdate = false;
    this.item_active = i;
    this.orderService.getOrderbyId(data.id).subscribe((res) => {
      if (!res.error) {
        this.item_detail = res.data;
        console.log(" this.item_detail", this.item_detail);
        this.item_detail.list_stamp_services = this.buildListServices(this.item_detail.services);
      }
    });
  }

  onSubmit() {
    this.item_active = 0;
    this.getData();
  }

  getData() {
    this.item_detail = undefined;
    let modelQuery = <any>{};
    if ($("#status").val()) {
      modelQuery.status = $("#status").val();
    }
    if ($("#typestamp").val()) {
      modelQuery.order_type = $("#typestamp").val();
    }
    if (this.logFilter.type && this.logFilter.type != -1) {
      modelQuery.type = this.logFilter.type;
    }
    if (this.logFilter.time && this.logFilter.time.length > 1) {
      modelQuery.from = moment(this.logFilter.time[0]).format("YYYY-MM-DD");
      modelQuery.to = moment(this.logFilter.time[1]).format("YYYY-MM-DD");
    }
    this.currentPage = 1;
    this.current_filter = modelQuery;
    this.loadData(modelQuery, this.isSorting);
  }

  delete(id) {
    this.confirmationService.confirm({
      message: "Bạn chắc chắn muốn xóa không?",
      header: "Xác nhận",
      icon: "fa fa-trash",
      accept: () => { },
    });
  }

  resetForm(frm: NgForm) {
    this.logFilter.status = -1;
    this.logFilter.type = -1;
    delete this.logFilter.time;
    $("#status").val("").trigger("change");
    $("#typestamp").val("").trigger("change");
    //frm.reset();
    this.getData();
  }

  /* pagination */
  setPage(page: number) {
    this.item_active = 0;
    if (page <= this.totalPage) {
      if (page < 1) {
        page = 1;
      } else if (page > this.totalPage) {
        page = this.totalPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(this.current_filter, this.isSorting);
      }
    } else {
      page = this.totalPage;
      $("#inputPage").val(page);
      this.toastr.warning("Số trang tối đa hiện tại là " + page, "", {
        timeOut: 4000,
        positionClass: "toast-bottom-right",
      });
      if (page < 1) {
        page = 1;
      } else if (page > this.totalPage) {
        page = this.totalPage;
      }
      //this.pager = this.pagerService.getPager(this.totalRow, this.currentPage, this.page_size);
      if (page != this.currentPage) {
        this.currentPage = page;
        this.loadData(this.current_filter, this.isSorting);
      }
    }
  }

  rowIndex(i: number) {
    if (this.currentPage == 1) {
      return i + 1;
    } else {
      return this.page_size * (this.currentPage - 1) + (i + 1); //currentPage start from: 0
    }
  }

  handleUpdated(event) {
    if (event) {
      this.loadData(this.paramsQuery, this.isSorting);
    }
  }

  backToComponent() {
    this._location.back();
  }

  goPage2(toPage: any) {
    toPage = parseInt(toPage);
    if (toPage && toPage > 0) {
      this.setPage(toPage);
    }
  }
  setSort(typeSort: string) {
    this.currentPage = 1;
    this.isSorting = typeSort;
    this.loadData(null, typeSort);
  }
  backUpdateWork(event) {
    this.isUpdate = false;
    if ((event.isBack = false)) {
      this.setSort(this.isSorting);
    }
  }
  _keyPress(event: any) {
    console.log(123123123);
    if (event.charCode !== 0) {
      const pattern = /[0-9]/;
      const inputChar = String.fromCharCode(event.charCode);
      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }
  checkIfDirty(event: any) {

  }
  buyStamp() {
    var listService: any = [];
    console.log("va1111", $("#modaltypestamp").val());
    var request: any = {};
    if (this.stamBuy.chongia) listService.push(1);
    if (this.stamBuy.baohanh) listService.push(2);
    if (this.stamBuy.tranhang) listService.push(3);
    if (this.stamBuy.dinhdanh) listService.push(5);
    request.services = listService;
    request.quantity = parseInt(this.stamBuy.soluong);
    if ($("#modaltypestamp").val()) {
      this.stamBuy.typeStamp = parseInt($("#modaltypestamp").val());
      request.order_type = this.stamBuy.typeStamp;
    } else {
      request.order_type = null;
    }
    // if (listService.length <= 0) {
    //   this.toastr.warning("Bạn phải chọn dịch vụ ", "", {
    //     timeOut: 3000,
    //     positionClass: "toast-bottom-right",
    //   });
    // } else {
    //   request.services = listService;
    // }

    // if (!this.stamBuy.soluong) {
    //   this.toastr.warning("Bạn phải nhập số lượng ", "", {
    //     timeOut: 3000,
    //     positionClass: "toast-bottom-right",
    //   });
    // } else request.quantity = parseInt(this.stamBuy.soluong);

    // if ($("#modaltypestamp").val()) {
    //   this.stamBuy.typeStamp = parseInt($("#modaltypestamp").val());
    //   request.order_type = this.stamBuy.typeStamp;
    // } else {
    //   this.toastr.warning("Bạn phải chọn loại tem ", "", {
    //     timeOut: 3000,
    //     positionClass: "toast-bottom-right",
    //   });
    // }

    if (request.services && request.quantity)
      this.orderService.createOrder(request).subscribe((res) => {
        if (!res.error) {
          this.lgModal.hide();
          this.toastr.success("Tạo đơn hàng thành công", "", {
            timeOut: 3000,
            positionClass: "toast-bottom-right",
          });
          this.currentPage = 1;
          this.item_active = 0;
          this.loadData(this.current_filter, this.isSorting);
        } else {
          this.toastr.error("Tạo đơn hàng thất bại", "", {
            timeOut: 3000,
            positionClass: "toast-bottom-right",
          });
        }
      });
  }

  downloadExcel() {
    let modelQuery = <any>{};
    if ($("#status").val()) {
      modelQuery.status = $("#status").val();
    }
    if (this.logFilter.type && this.logFilter.type != -1) {
      modelQuery.type = this.logFilter.type;
    }
    if (this.logFilter.time && this.logFilter.time.length > 1) {
      modelQuery.from = moment(this.logFilter.time[0]).format("YYYY-MM-DD");
      modelQuery.to = moment(this.logFilter.time[1]).format("YYYY-MM-DD");
    }

    modelQuery.sort_by = "created_at:" + this.isSorting;
    var url = environment.api_evs + "/orders/excel?";
    if (modelQuery.status) url += "status=" + modelQuery.status;
    if (modelQuery.from) url += "&from=" + modelQuery.from;
    if (modelQuery.to) url += "&to=" + modelQuery.to;
    url += "&sort_by=created_at:" + this.isSorting;
    if (localStorage.getItem("Access-Token")) {
      url += "&Access_Token=" + localStorage.getItem("Access-Token");
    }
    location.href = url;
  }

  // Tuanba:31/05/2022: Quản lý đơn hàng tem trắng
  openOder() {
    this.lgModal.show();
  }
  checkOrderType: any;
  cancelOrder(item) {
    this.checkOrderType = item.order_type

    this.cancelRequest.show();
  }

  ngOnInit() {
    var that = this;
    $('#inputStart').datepicker({ format: 'dd-mm-yyyy' });
    $('#inputEnd').datepicker({ format: 'dd-mm-yyyy' });
    $('.input-daterange').datepicker();
    this.initSelect2();
    this.langSub = this.translate.onLangChange.subscribe(() => {
      this.initSelect2();
      this.updateListServicesTranslation();
    });
    $("#province").select2({
      placeholder: "-- Chọn Tỉnh/TP --",
      allowClear: false,
    });
    $("#district").select2({
      placeholder: "-- Chọn Quận/Huyện --",
      allowClear: false,
    });
    $("#province").on("select2:select", function (e) {
      $(".select2-selection__rendered").removeAttr("title");
      var id = e.target.value;
      that.loadDistrictData(id, null);
    });

    $("#district").on("select2:select", function (e) {
      $(".select2-selection__rendered").removeAttr("title");
    });

    $("#modaltypestamp").on("select2:select", function (e) {
      that.stamBuy.typeStamp = parseInt(e.target.value);
      console.log("va", e.target.value);
      if (e.target.value == 1) {
        that.stamBuy.chongia = true;
        that.stamBuy.baohanh = true;
        that.stamBuy.tranhang = true;
        that.stamBuy.dinhdanh = true;
        that.isDisableService = true;
      } else {
        that.stamBuy.chongia = false;
        that.stamBuy.baohanh = false;
        that.stamBuy.tranhang = false;
        that.stamBuy.dinhdanh = false;
        that.isDisableService = false;
      }
    });
    // this.clearDataForm();
    //this.getCity();
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.isSorting = "desc";
      if (params.batch_id && params.logFilter.status) {
        this.current_filter.batch_id = params.batch_id;
        this.logFilter.status = params.status;
        $("#status").val(params.status);
        this.loadData(this.current_filter, this.isSorting);
      } else {
        this.loadData(this.current_filter, this.isSorting);
      }
    });

    //this.loadData();
  }

  initSelect2() {
    $('#status').select2({
      placeholder: this.translate.instant('TRANG_THAI_LABEL'),
      allowClear: false,
      minimumResultsForSearch: -1,
    });
    $('#typestamp').select2({
      placeholder: this.translate.instant('LOAI_TEM'),
      allowClear: false,
      minimumResultsForSearch: -1,
    });
    $('#modaltypestamp').select2({
      placeholder: this.translate.instant('LOAI_TEM'),
      allowClear: false,
      minimumResultsForSearch: -1,
    });
    $('#province').select2({
      placeholder: this.translate.instant('TINH_THANH'),
      allowClear: false,
    });
    $('#district').select2({
      placeholder: this.translate.instant('QUAN_HUYEN_LABEL'),
      allowClear: false,
    });
  }

  buildListServices(servicesStr: string): any[] {
    const serviceMap = {
      '1': { id: 1, key: 'CHONG_GIA' },
      '2': { id: 2, key: 'BAO_HANH' },
      '3': { id: 3, key: 'TRAN_HANG' },
      '5': { id: 5, key: 'DINH_DANH' },
    };
    const list: any[] = [];
    const services = servicesStr.split(',');
    for (let i = 0; i < services.length; i++) {
      const svc = serviceMap[services[i]];
      if (svc) {
        list.push({ id: svc.id, name: this.translate.instant(svc.key) });
      }
    }
    return list;
  }

  updateListServicesTranslation() {
    if (this.orders && this.orders.length > 0) {
      for (let i = 0; i < this.orders.length; i++) {
        if (this.orders[i].services) {
          this.orders[i].list_stamp_services = this.buildListServices(this.orders[i].services);
        }
      }
    }
    if (this.item_detail && this.item_detail.services) {
      this.item_detail.list_stamp_services = this.buildListServices(this.item_detail.services);
    }
  }

  ngOnDestroy() {
    if (this.langSub) {
      this.langSub.unsubscribe();
    }
  }

  submitCancelOrder() {
    console.log("this.item_detail", this.item_detail);
    this.orderService.cancelOrder(this.item_detail.id).subscribe(
      (res) => {
        if (!res.error) {
          this.toastr.success("Hủy yêu cầu thành công", "", {
            timeOut: 3000,
            positionClass: "toast-bottom-right",
          });
          this.currentPage = 1;
          this.item_active = 0;
          this.loadData(this.current_filter, this.isSorting);
          this.cancelRequest.hide();
        } else {
          this.toastr.error("Hủy yêu cầu thất bại", "", {
            timeOut: 3000,
            positionClass: "toast-bottom-right",
          });
          this.cancelRequest.hide();
        }
      },
      (error) => {
        this.toastr.error(error.message, '', {
          timeOut: 3000,
          positionClass: 'toast-bottom-right',
        });
        this.cancelRequest.hide();
      }
    );
  }

  resetModal() {
    this.stamBuy = {};
    $('#modaltypestamp').val('').trigger('change');
    this.isDisableService = false;
  }

  onSubmitModal(form) {
    console.log('12312312', form)
    this.buyStamp();
  }

  /***Tuanba:17-11-2022: Thay api xuất báo cáo **/
  exportReport() {
    this.messageExport = '';
    $('.stampBoxStampAlertAdd').css('opacity', '0');
    const modelQuery = <any>{};
    if ($('#status').val()) {
      modelQuery.status = $('#status').val();
    }
    if ($('#typestamp').val()) {
      modelQuery.order_type = $('#typestamp').val();
    }
    if (this.logFilter.type && this.logFilter.type != -1) {
      modelQuery.type = this.logFilter.type;
    }
    if (this.logFilter.time && this.logFilter.time.length > 1) {
      modelQuery.from = moment(this.logFilter.time[0]).format('YYYY-MM-DD');
      modelQuery.to = moment(this.logFilter.time[1]).format('YYYY-MM-DD');
    }
    modelQuery.sort = `created_at:${this.isSorting}`
    const body = {
      exportTypeEnum: 'STAMP_BUYING',
      fields: modelQuery
    };
    this.exportService.exportReport(body).subscribe((res) => {
      if (res.code == 1) {
        this.messageExport = this.translate.instant('HE_THONG_DANG_XU_LY');
        $('.stampBoxStampAlertAdd').css('opacity', '1');
        setTimeout(() => {
          $('.stampBoxStampAlertAdd').css('opacity', '0');
        }, 5000);
      } else {
        $('.stampBoxStampAlertAdd').css('opacity', '0');
        this.toastr.error(res.message, this.translate.instant('THONG_BAO'), {
          timeOut: 4000,
          positionClass: 'toast-bottom-right'
        })
      }
    }, (error) => {
      this.toastr.error(error.message, this.translate.instant('THONG_BAO'), {
        timeOut: 4000,
        positionClass: 'toast-bottom-right'
      })
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/order/order/order.component.ts